import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { useCrm } from "../../pages/crm/CrmApp";
import { STATUS } from "../../lib/crmApi";
import { inputCls, Labeled } from "../market/admin/ui";

const EMPTY = { name: "", company: "", phone: "", email: "", status: "prospecto", source: "", notes: "", value: 0, tags: [], owner_user_id: "" };
const SOURCES = ["WhatsApp", "Facebook", "Instagram", "Recomendación", "Sitio web", "Llamada", "Visita", "Otro"];

export const ContactForm = ({ open, initial, onClose, onSaved }) => {
  const { api, isOwner } = useCrm();
  const [f, setF] = useState(EMPTY);
  const [team, setTeam] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!open) return;
    setF({ ...EMPTY, ...(initial || {}) });
    setErr("");
    if (isOwner) api("/team").then(setTeam);
  }, [open, initial]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const body = { ...f, value: Number(f.value) || 0, owner_user_id: f.owner_user_id || null };
      const saved = await api(f.id ? `/contacts/${f.id}` : "/contacts", { method: f.id ? "PUT" : "POST", body });
      onSaved?.(saved);
      onClose();
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-md overflow-y-auto rounded-2xl" data-testid="crm-contact-form">
        <DialogHeader><DialogTitle>{f.id ? "Editar cliente" : "Nuevo prospecto o cliente"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <Labeled label="Nombre"><input required className={inputCls} value={f.name} onChange={set("name")} data-testid="crm-contact-name" /></Labeled>
          <div className="grid grid-cols-2 gap-3">
            <Labeled label="Empresa"><input className={inputCls} value={f.company} onChange={set("company")} data-testid="crm-contact-company" /></Labeled>
            <Labeled label="WhatsApp"><input className={inputCls} value={f.phone} onChange={set("phone")} placeholder="55 1234 5678" data-testid="crm-contact-phone" /></Labeled>
          </div>
          <Labeled label="Correo"><input type="email" className={inputCls} value={f.email} onChange={set("email")} data-testid="crm-contact-email" /></Labeled>
          <div className="grid grid-cols-2 gap-3">
            <Labeled label="Etapa">
              <select className={inputCls} value={f.status} onChange={set("status")} data-testid="crm-contact-status">
                {Object.entries(STATUS).map(([k, s]) => <option key={k} value={k}>{s.label}</option>)}
              </select>
            </Labeled>
            <Labeled label="Valor estimado"><input type="number" min="0" className={inputCls} value={f.value} onChange={set("value")} data-testid="crm-contact-value" /></Labeled>
          </div>
          <Labeled label="¿Cómo llegó?">
            <select className={inputCls} value={f.source} onChange={set("source")} data-testid="crm-contact-source">
              <option value="">—</option>
              {SOURCES.map((s) => <option key={s}>{s}</option>)}
            </select>
          </Labeled>
          {isOwner && team.length > 1 && (
            <Labeled label="Vendedor asignado">
              <select className={inputCls} value={f.owner_user_id || ""} onChange={set("owner_user_id")} data-testid="crm-contact-owner">
                <option value="">Yo</option>
                {team.filter((t) => t.role !== "owner" && t.active).map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </Labeled>
          )}
          <Labeled label="Notas"><textarea rows={3} className={inputCls} value={f.notes} onChange={set("notes")} data-testid="crm-contact-notes" /></Labeled>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold text-white" style={{ background: "var(--crm)" }} data-testid="crm-contact-save">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Guardar
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
